export interface SitemapStoreType {
  items: SitemapCountry[];
}

export interface SitemapCountry {
  country: string;
  projects: SitemapCountryProjects[];
}

export interface SitemapCountryProjects {
  id: string;
  projectName: string;
}

export enum SitemapStoreKind {
  INITIAL = 'INITIAL',
}

export interface SitemapStoreAction {
  type: SitemapStoreKind;
  payload: SitemapCountry[];
}
